import { BackendSocket } from '../../hooks/use-socket';
import {
    current,
    meta,
    next,
    resetCalls,
    resetNextCalls,
    resetGameToGo,
    pickedCards,
    resetWinners,
    resetFireBallStatus,
} from '../../stores/backend';
import { BingoGameModeChange } from '../../types/bingo-events/in/backend/game-mode-change';
import { BackendPayload } from './payloads';
import { isSuspended } from '../../lib/suspension';
import { deferUntilCurrentLoaded } from './session';

export const onGameModeChange = (
    socket: BackendSocket,
    { payload }: { payload: BackendPayload }
) => {
    const callback = async (message: BingoGameModeChange) => {
        if (isSuspended()) return;
        if (
            deferUntilCurrentLoaded(() => {
                void callback(message);
            })
        )
            return;
        const { data } = message;
        const expectedSession =
            data.status === 'GAME_MODE'
                ? next.game_sid.value
                : current.game_sid.value;
        if (data.gameSessionId !== expectedSession) return;
        if (
            data.status === 'GAME_MODE' &&
            current.game_sid.value === data.gameSessionId &&
            current.game_mode.value === 'GAME_MODE'
        )
            return;
        const connectionId = socket.id;
        switch (data.status) {
            case 'GAME_OVER':
                current.merge({
                    player_cards: {},
                    game_mode: data.status,
                });
                resetCalls();
                resetNextCalls();
                resetGameToGo();
                break;

            case 'GAME_MODE':
                resetCalls();
                resetNextCalls();
                resetGameToGo();
                resetWinners();
                resetFireBallStatus();
                pickedCards.selected.set([]);
                // Reload both games from the server (same as on connect) instead of
                // promoting the cached next game, which may hold stale data such as
                // a jackpot that was won and reset during the previous game.
                if (
                    !(await payload.loadGame()) ||
                    isSuspended() ||
                    socket.id !== connectionId
                )
                    return;
                // Keep the duplicate GAME_MODE guard above effective even if the
                // server response hasn't flipped the mode yet.
                if (
                    current.game_sid.value === data.gameSessionId &&
                    current.game_mode.value !== 'GAME_MODE'
                )
                    current.game_mode.set(data.status);
                if (
                    !(await payload.loadGame(true)) ||
                    isSuspended() ||
                    socket.id !== connectionId
                )
                    return;
                payload.getPickedCards();
                break;

            case 'GAME_CANCELLED':
                meta.modals.gameCancelled.set(true);
                current.game_mode.set(data.status);
                break;
        }
    };

    socket.on('bingo:gameModeChange', callback);

    return () => {
        socket.off('bingo:gameModeChange', callback);
    };
};
